import { Stack } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import { DownloadSimpleIcon, FilesIcon, XIcon } from '@phosphor-icons/react'
import { TextWithEllipsis } from 'ComponentLibrary/src/piazza/text'
import { IconButton } from 'ComponentLibrary/src/piazza'
import { MessageFile } from 'ComponentLibrary/src/molecules/Message/types'

export type AttachmentProps = {
    index: number
    file: MessageFile
} & (DownloadOnlyProp | RemoveOnlyProp) // Design doesnt currently accompany both, so far its always xor

type DownloadOnlyProp = {
    onDownload: () => void
}

type RemoveOnlyProp = { onRemove: () => void }

export function Attachment({ index, file, ...props }: AttachmentProps) {
    return (
        <Stack
            direction="row"
            key={index}
            justifyContent="space-between"
            alignItems="center"
            height="30px"
            sx={{
                '&:hover': {
                    '& .action-container': {
                        display: 'flex',
                    },
                },
            }}
        >
            <Stack direction="row" gap={tokens.SizingSpacing100} sx={{ cursor: 'default', maxWidth: '220px' }} alignItems="center">
                <FilesIcon size={tokens.SizingIconM} color={tokens.ColorIconBoldest} style={{ flexShrink: 0 }} />
                <TextWithEllipsis
                    typographyProps={{ variant: 'headline4', color: tokens.ColorTextBoldest }}
                    tooltipText={file.name}
                    fullWidth
                >
                    {file.name}
                </TextWithEllipsis>
            </Stack>
            {'onDownload' in props && props.onDownload !== undefined && (
                <IconButton
                    size="medium"
                    variant="tertiary"
                    icon={<DownloadSimpleIcon size={tokens.SizingIconM} color={tokens.ColorIconBoldest} />}
                    onClick={props.onDownload}
                />
            )}
            {'onRemove' in props && props.onRemove !== undefined && (
                <Stack className="action-container" display="none" direction="row" gap={tokens.SizingSpacing200} alignItems="center">
                    <IconButton size="small" icon={<XIcon />} onClick={props.onRemove} variant="tertiary" />
                </Stack>
            )}
        </Stack>
    )
}
